import BottomNavigation from "components/BottomNavigation"
import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  Row,
} from "reactstrap"
import { change, FieldArray, isDirty, reset } from "redux-form"
import FeaturesPreview from "./featuresPreview"
import { renderFeatures } from "./utils"

const FeaturesTab = ({
  platformSettings,
  icons,
  change,
  resetForm,
  isDirty,
  tabIsActive,
  handleSave,
  handleNext,
  handleBack,
}) => {
  const [selectedFeature, setSelectedFeature] = useState({})
  const [selectedField, setSelectedField] = useState("")
  const [selectIconModalIsOpen, setSelectIconModalIsOpen] = useState(false)
  const [showAlertModal, setShowAlertModal] = useState(false)
  const [showWarningModal, setShowWarningModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  const handleEditIcon = (menu, field) => {
    setSelectedFeature(menu)
    setSelectedField(field)
    setSelectIconModalIsOpen(true)
  }

  const handleStatusChange = field => {
    setSelectedField(field)
    setShowWarningModal(true)
  }

  return (
    <React.Fragment>
      <Row>
        <Col xl={8}>
          <Card className="mt-3">
            <CardHeader style={{ minWidth: "300px" }}>
              <h4>Experience level features menu</h4>
            </CardHeader>
            <CardBody>
              <Row>
                <p>
                  You can choose which features to make accessible in an experience
                  by turning them on/off below. You can set the default menu
                  design by customizing the icons for each feature.
                </p>
              </Row>
              <Row>
                <ListGroup>
                  <ListGroupItem
                    style={{
                      border: "none",
                      margin: "0",
                      paddingBottom: "0",
                    }}
                  >
                    <Row>
                      <Col xs="auto" style={{ minWidth: "78px" }}>
                        <label>Icon</label>
                      </Col>
                      <Col>
                        <label>Features</label>
                      </Col>
                      <Col xs="auto">
                        <label>On/Off</label>
                      </Col>
                    </Row>
                  </ListGroupItem>
                  <FieldArray
                    name="menu"
                    component={renderFeatures}
                    handleEditIcon={handleEditIcon}
                    handleStatusChange={handleStatusChange}
                  />
                </ListGroup>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation
            handleBack={handleBack}
            handleSave={handleSave}
            handleNext={handleNext}
          />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <Row className="mb-1">
            <p style={{ textAlign: "center", margin: "0px" }}>
              <b>PREVIEW</b>
            </p>
          </Row>
          <FeaturesPreview />
          <Row>
            <p style={{ textAlign: "center", margin: "0px" }}>
              (Please be aware that the icons will match the text color)
            </p>
          </Row>
        </Col>
      </Row>
      <ModalComponent
        title="Set Icon"
        open={selectIconModalIsOpen}
        onClose={() => {
          setSelectIconModalIsOpen(false)
        }}
      >
        {icons.map(icon => (
          <img
            key={icon.id}
            src={icon.url}
            style={
              selectedFeature?.icon?.id === icon.id
                ? {
                    width: "30px",
                    height: "auto",
                    cursor: "pointer",
                    margin: "4px",
                    border: "1px solid red",
                  }
                : {
                    width: "30px",
                    height: "auto",
                    cursor: "pointer",
                    margin: "4px",
                  }
            }
            onClick={() => {
              change(`features.${selectedField}.icon.id`, icon?.id)
              change(`features.${selectedField}.icon.url`, icon?.url)
              change(`features.${selectedField}.new_icon`, icon?.id)
              setSelectIconModalIsOpen(false)
            }}
          />
        ))}
      </ModalComponent>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
      <Modal isOpen={showWarningModal} centered={true}>
        <ModalBody>
          <Row>
            <h5>
              If you turn off the feature, all the related menu items, entities
              and analytics will be deleted for all the Experiences within this
              client!
            </h5>
          </Row>
          <Row className="d-flex justify-content-end mt-2">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Cancel"
                onClick={() => {
                  change(selectedField, true)
                  setShowWarningModal(false)
                }}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="OK"
                onClick={() => setShowWarningModal(false)}
              />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  platformSettings: state.PlatformSettings.platformSettings,
  icons: state.PlatformSettings.icons,
  isDirty: isDirty(FORM_NAMES.PLATFORM_SETTINGS)(state, ...["features"]),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PLATFORM_SETTINGS, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.PLATFORM_SETTINGS)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesTab)
